import { Routes } from "@angular/router";
import { FaqComponent } from "./faq.component";
import { ProspectiveMembersComponent } from "./prospective-members/prospective-members.component";
import { MembersComponent } from "./members/members.component";
import { ProspectiveProducersComponent } from "./prospective-producers/prospective-producers.component";

export const faqRoutes: Routes = [
    {
        path: 'faq',
        title: 'FAQ',
        component: FaqComponent,
        children: [
            {
                path: 'prospective-members',
                title: 'Prospective members',
                component: ProspectiveMembersComponent
            },
            {
                path: 'members',
                title: 'Members',
                component: MembersComponent
            },
          {
            path: 'prospective-producers',
            title: 'Prospective Businesses and Producers',
            component: ProspectiveProducersComponent
          }
        ]
    }
]
